module.exports = __webpack_public_path__ + "img/no-gpa.dfe74048.png";